import { useCallback } from 'react';
import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';
import { useStaticPermissions } from 'common/auth/Authorize';
import { LaunchDarklyFeatureFlagKeys } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';
import { useCustomFieldsAndObjectsIntl } from '../translations/useCustomFieldsAndObjectsIntl';
import { CustomFieldsAndObjectsNavItem, navItems } from './CustomFieldsAndObjects.constants';

export function useCustomFieldAndObjectRoutes(): CustomFieldsAndObjectsNavItem[] {
  const flags = useDarkly();
  const intl = useCustomFieldsAndObjectsIntl();
  const isFlagOnOrUndefined = useCallback(
    (flag?: LaunchDarklyFeatureFlagKeys) => typeof flag === 'undefined' || !!flags[flag],
    [flags]
  );
  const verifyPermission = useStaticPermissions();

  return navItems
    .map((item) => ({ ...item, label: intl[`${item.path}` as keyof typeof intl] as string }))
    .filter((item) => {
      const deniedPermission = item.permissions.find(
        (permission) => !verifyPermission({ permissionName: permission.name }, true)[permission.action]
      );

      return !deniedPermission && isFlagOnOrUndefined(item.useDarkly);
    });
}
